(function(){
    'use strict';
    angular.module('app').controller('ProffOfDeliveryModalController', ProffOfDeliveryModalController);

    ProffOfDeliveryModalController.$inject = [
        'imageSrc',
        'label',
        '$uibModalInstance'
    ];

    function ProffOfDeliveryModalController(
        imageSrc, 
        label,
        $uibModalInstance
    ) {
        const vm = this;
        vm.close = close;

        init();

        function init() {
            vm.label = label; 
            vm.imageSrc = imageSrc;
        }

        function close() {
            $uibModalInstance.dismiss();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/jobs/ProffOfDeliveryModalController.js